export const POSTER_MOBILE_TIMELINE_HEIGHT_RATIO = 0.5;
export const MOBILE_TIMELINE_MIN_HEIGHT = 100;
export const MOBILE_TIMELINE_MAX_HEIGHT = 800;
export interface PosterEditorMobileTimelineProps {}
